<template>
<div>
  <el-scrollbar class="bar-visible" v-if="activeView === null" >
  <el-row type="flex" justify="center" class="settings-summary-wrapper">
    <el-col :span="12">
      <el-row v-for="(menuBox, index) in settingsMenu" :key="index" :gutter="10">
        <el-col :span="12" v-for="item in menuBox" :key="item.id">
          <div class="settings-summary-box">
            <!-- title -->
            <div class="title">{{item.name}}</div>
            <!-- description -->
            <div class="description">
              <div v-for="(desc, index) in item.desc" :key="index">
                {{desc}}
              </div>
            </div>
            <!-- current status -->
            <div v-if="item.data !== null" class="data">
              <div v-for="(status, index) in item.data" :key="index" v-html="status">
              </div>
            </div>
            <!-- set active view -->
            <el-button class="settings-button" size="small" @click="setActiveView(item)">설정하기</el-button>
          </div>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
  </el-scrollbar>
  <slot v-else name="activeView"></slot>
</div>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import upperFirst from 'lodash/upperFirst';
import findIndex from 'lodash/findIndex';

export default {
  name: 'WSettingsSummary',
  props: {
    menu: {
      type: Array,
    },
  },
  data() {
    return {
      activeView: null,
      activeMenu: {},
      data: {},
    };
  },
  computed: {
    settingsMenu() {
      // TODO: 필요 시 정렬 기능 추가
      const lineMaxBoxCnt = 3;
      const menu = this.menu;
      const maxIndex = menu.length - 1;
      const size = Math.ceil(menu.length / lineMaxBoxCnt);

      const settingsMenu = [];
      for (let i = 0; i <= size; i += 1) {
        const subMenu = [];
        const index = i * lineMaxBoxCnt;
        for (let cnt = index; cnt < lineMaxBoxCnt + index; cnt += 1) {
          if (cnt <= maxIndex) {
            subMenu.push(menu[cnt]);
          } else {
            break;
          }
        }
        settingsMenu.push(subMenu);
      }
      return settingsMenu;
    },
    autoMoveMenuInfo() {
      return this.$store.getters.autoMoveMenuInfo;
    },
  },
  watch: {
    autoMoveMenuInfo: {
      immediate: true,
      handler(val) {
        if (!isEmpty(val) && val.length >= 2) {
          const index = findIndex(this.menu, (item) => item.id === val[1].id);
          if (index >= 0) {
            this.setActiveView(this.menu[index]);
            if (val.length === 2) {
              this.$store.dispatch('setAutoMoveMenuInfo', null);
            }
          }
        }
      },
    },
  },
  methods: {
    clearActiveView() {
      this.activeView = null;
      this.activeMenu = {};
      this.$emit('change', this.activeView, this.activeMenu);
    },
    setActiveView(menu) {
      this.activeView = `W${upperFirst(menu.id)}`;
      this.activeMenu = menu;
      this.$emit('change', this.activeView, this.activeMenu);
    },
    findMenuById(id) {
      const index = findIndex(this.menu, (item) => item.id === id);
      return index >= 0 ? this.menu[index] : null;
    },
    loadData() {
      const dummyData = {
        deviceCount: 25,
        uncheckedDeviceCount: 25,
        userCount: 10,
        operStatus: '정상',
      };

      const data = {
        deviceRegistration: [],
        userAndAuthManagement: [],
        operationSettings: [],
      };

      if (!isNil(dummyData.deviceCount)) {
        data.deviceRegistration.push(`현재 관리 중인 장비 수는 <em>${dummyData.deviceCount}대</em> 입니다.`);
      }
      if (!isNil(dummyData.uncheckedDeviceCount)) {
        data.deviceRegistration.push(`현재 미확인된 신규 장비 등록 대수는 <em>${dummyData.uncheckedDeviceCount}대</em> 입니다.`);
      }
      if (!isNil(dummyData.userCount)) {
        data.userAndAuthManagement.push(`현재 등록된 사용자는 총 <em>${dummyData.userCount}명</em> 입니다.`);
      }
      if (!isNil(dummyData.operStatus)) {
        data.operationSettings.push(`현재 WatchAll 운영 상태는 <em>${dummyData.operStatus}</em> 입니다.`);
      }

      this.data = data;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/template/SettingsSummary.vue